const headers = {
  name: "Expense categories",
  navigate: {
    path: [
      {
        name: "Expenses",
        path: "/app/expenses",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
